import eventMenuClose from './navigation';

/**
 * Handles requesting the contact us message from the server/backend as well
 * as expanding and collapsing the contact us message container.
 */
document.addEventListener('DOMContentLoaded', () => {
    const contactUsBtn = document.querySelector('div[data-bs-toggle="contact-us"]');
    if (!contactUsBtn) return;

    contactUsBtn.addEventListener('click', () => {
        const body = contactUsBtn.querySelector('div[data-contact-us-message]');

        if (!body.innerHTML) {
            window.ajax({
                method: 'get',
                url: 'contactus',
                documentType: 'json',
                success: (data) => {
                    const { message } = data;
                    body.innerHTML = message;
                },
                failure: (err) => console.error(err),
            });
        }
    });

    // The following code exists because aurion-ui wasn't working.
    // TODO: remove the code here and fix in in aurion-ui src/components/toast-dialog/scripts/functions.js
    const tDialog = document.querySelector('.toast-dialog');

    setTimeout(() => {
        tDialog.classList.add('enter');
        tDialog.classList.add('showing');
    }, 1000);

    const tDialogToast = document.querySelector('.toast-dialog .toast');
    const tDialogClose = document.querySelector('.toast-dialog .toast .btn-close');
    tDialog.addEventListener('click', openElement);

    function openElement() {
        tDialog.classList.add('expand');
        tDialog.classList.remove('d-none');

        tDialogToast.classList.add('enter', 'showing');
        tDialogClose.addEventListener('click', closeElement);
        tDialog.removeEventListener('click', openElement);
    }

    function closeElement() {
        tDialogToast.classList.remove('enter', 'showing');
        tDialogClose.removeEventListener('click', closeElement);

        tDialog.classList.remove('expand');
        tDialog.classList.add('d-none');

        setTimeout(() => {
            tDialogToast.classList.remove('enter', 'showing');
            tDialog.addEventListener('click', openElement);
        }, 500);
    }
});

/**
 * Handles the contact us popup when in mobile view. The contact us button is
 * hidden in mobile view and can only be seen inside of the nav menu. When the
 * nav menu item is clicked, the nav menu hides and displays the contact us popup.
 */
document.addEventListener('DOMContentLoaded', () => {
    const settingsMenu = document.querySelector('ul[aria-controls="menu-settings-list"]');

    if (settingsMenu) {
        const settingsMenuItems = settingsMenu.querySelectorAll('a');
        const mobileMenuForSettings = document.querySelector('.nav-menu-item[aria-controls="menu-mobile"]');

        Array.from(settingsMenuItems).forEach((item) => {
            if (item.getAttribute('data-controller-id') === 'contactus') {
                item.addEventListener('click', () => {
                    document.querySelector('#contact-us-btn').click();
                    mobileMenuForSettings.dispatchEvent(eventMenuClose);
                });
            }
        });
    }
});
